import * as React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import "./QuantityAdjuster.css";

interface QuantityAdjusterProps {
    value: number; // Current quantity selected
    orderedValue: number; // Value ordered
    maxQuantityOrdered: number; // Maximum allowed quantity
    onChange: (newValue: number) => void; // Function called when the value changes
}

export default function QuantityAdjuster({
                                             value,
                                             orderedValue,
                                             maxQuantityOrdered,
                                             onChange,
                                         }: QuantityAdjusterProps) {
    const handleIncrement = () => {
        if (value < maxQuantityOrdered) {
            onChange(value + 1); // Increase the quantity
        }
    };

    const handleDecrement = () => {
        if (value > 0) {
            onChange(value - 1); // Decrease the quantity
        }
    };

    if (orderedValue !== 0) {
        return (
            <Typography
                sx={{
                    fontFamily: 'PT Serif',
                    fontWeight: 400,
                    fontSize: "13px"
                }}
            >
                Qty: {orderedValue}
            </Typography>
        );
    }

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: "8px", width: "73px"}}>
            <IconButton
                className={'remove-quantity-button'}
                onClick={handleDecrement}
                disabled={value === 0}
                sx={{ padding: 0, minWidth: 28, height: 28 }}
            >
                <RemoveIcon sx={{ fontSize: 20 }} />
            </IconButton>
            <Typography
                className={'quantity-adjuster-text'}
            >
                {value}
            </Typography>
            <IconButton
                className={'add-quantity-button'}
                onClick={handleIncrement}
                disabled={value >= maxQuantityOrdered}
                sx={{ padding: 0, minWidth: 28, height: 28 }}
            >
                <AddIcon sx={{ fontSize: 20 }} />
            </IconButton>
        </Box>
    );
}
